<template>
  <v-container class="box-container ma-0 pa-2" justify="center" align="center" style="width: 100%; height: 100%">
    <v-alert type="info" class="row-header ma-2 pa-2" :class="isOnMobile ? '' : 'mr-8'" dense>
      <span class="my-1 subtitle-2">В това меню можете да изтеглите декларацията, която ни е необходима да одобрим акаунта Ви в системата. Можете да подпишете декларацията с електорнен подпис и да я качите или да я заверите нотариално и да ни я изпратите по куриер.</span>
    </v-alert>
    <div class="row-header" v-if="!error_message">
      <v-row class="ma-2 pa-0">
        <t-button btnText="Изтегли декларация" btnIcon="mdi-download" @click.native="showDeclaration()" />
        <input style="visibility: hidden; width: 2px" type="file" ref="refUpoadDeclaration" class="custom-file-input" @change="uploadSignedDeclaration($event, user.eik)" accept="application/pdf" />
        <t-button btnText="Качи подписана декларация" btnIcon="mdi-upload" @click.native="$refs['refUpoadDeclaration'].click()" />
      </v-row>
    </div>

    <v-dialog hide-overlay v-model="modalDeclaration" style="width: 0px; height: 0px" width="0px" height="0px">
      <v-card ref="refDeclarationDialogContent"></v-card>
    </v-dialog>

    <v-dialog hide-overlay v-model="modalPreviewDeclaration" :width="declarationWidth + 16" :style="'width: ' + declarationWidth + 'px; height: ' + declarationHeight + 'px;'">
      <v-card class="ma-0 pa-0" style="width: 100%; height: 100%">
        <v-container class="elevation-3" :style="isInDarkMode ? 'background-color: #363636;' : '' + 'overflow: hidden; width: ' + declarationWidth + 'px;'">
          <v-row justify="center">
            <t-button btnText="Изтегли" btnIcon="mdi-download" @click.native="download()" />
            <v-spacer></v-spacer>
            <t-button :btnDisabled="isSaveDisabled" btnText="Затвори" btnIcon="mdi-close-octagon" :btnColor="'red'" :iconLeft="false" @click.native="modalPreviewDeclaration = false" />
          </v-row>

          <v-container v-if="user" class="a4border" color="white" align="center" justify="center" ref="refDeclarationContent" :style="'overflow: hidden; width: ' + declarationWidth + 'px; height: ' + declarationHeight + 'px;'">
            <br />
            <br />
            <v-row align="center" justify="center">
              <p class="title" style="white-space: nowrap">Декларация</p>
            </v-row>
            <br />
            <br />
            <br />
            <v-row align="center" justify="center">
              <p style="width: 100%; text-align: center">За идентификация на фирма</p>
            </v-row>
            <br />
            <br />
            <v-row align="center" justify="center">
              <v-col>
                <v-row class="ma-0 pa-0">
                  <p slot="prepend" class="text-no-wrap pr-2">{{ "Долуподписаният: " + user.firstName + " " + user.middleName + " " + user.lastName }}</p>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col>
                <p>{{ "в качеството си на представител на фирма: " + user.oCuserCompanyName + " с ЕИК: " + user.eik }}</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col>
                <p>желая да бъда регистриран в системата Tremol Assistant.</p>
              </v-col>
            </v-row>
            <br />
            <br />
            <br />
            <br />
            <br />
            <v-row align="start" justify="center">
              <v-col cols="4">
                <p>{{ "Дата: " + new Date().toTremolFpStringShort() }}</p>
              </v-col>
              <!-- <v-col cols="3">
              <v-dialog ref="caldendarDialogRef" v-model="modalCalendar" :return-value.sync="date" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :dark="false" v-on="on" maxlength="10" height="17" dense fluid color="default" :value="new Date(date).toTremolFpStringShort()"></v-text-field>
                </template>
                <v-date-picker firstDayOfWeek="1" type="date" locale="bg" v-model="date">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalCalendar = false">Отказ</v-btn>
                  <v-btn text color="primary" @click="$refs.caldendarDialogRef.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col> -->
              <v-col cols="6" align="end" justify="end">
                <p>Декларатор: __________________</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="end" class="ma-0 pa-0">
              <v-col cols="9" class="ma-0 pa-0"></v-col>
              <v-col cols="3" class="ma-0 pa-0">
                <p>/ Подпис /</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="end" class="ma-0">
              <v-col cols="9" class="ma-0 pa-1"></v-col>
              <v-col cols="3" class="ma-0 pa-1">
                <p>/ Печат /</p>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card>
    </v-dialog>
    <div id="dpi"></div>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage, DataPropType } from "../../js/DataManager";
// eslint-disable-next-line no-unused-vars
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
//import verifyPDF from "pdf-signature-reader";
//import RobotoFont from "../assets/fonts/Roboto";

export default {
  components: {},
  data() {
    return {
      propType: DataPropType,
      isSaveDisabled: false,
      datatype: null,
      declarationWidth: 0,
      declarationHeight: 0,
      modalCalendar: false,
      modalDeclaration: false,
      modalPreviewDeclaration: false,
      date: new Date().toStringWithFormat("yyyy-MM-dd"),
      user: null,
      error_message: null,
      rules: {
        required: (v) => (!!v || "Задължително поле") && (v.length >= 2 || "Невалидна стойност"),
      },
    };
  },
  methods: {
    setTitleAndData(meta, error) {
      this.isLoading = false;
      this.datatype = meta.datatype;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(DataManager.DataType.user);

        this.$nextTick(() => {
          var dpi = document.getElementById("dpi");
          this.declarationWidth = dpi.offsetWidth * 21;
          this.declarationHeight = dpi.offsetHeight * 29.7;
          this.modalDeclaration = false;
        });
      } else {
        this.error_message = error.Message;
        this.dialogLoader.showError(error.Message, { location: "center" });
      }
    },
    objectHasNoNulls(o) {
      return Object.values(o).every((o) => o != null && o != undefined && o != "");
    },
    showDeclaration() {
      this.$nextTick(() => {
        this.modalPreviewDeclaration = true;
      });
    },
    async download() {
      this.$nextTick(() => {
        this.modalDeclaration = true;
        var vm = this;
        this.$nextTick(() => {
          this.$refs.refDeclarationContent.setAttribute("style", "max-width: " + this.declarationWidth + "px; min-width: " + this.declarationWidth + "px; width: " + this.declarationWidth + "px; height: " + this.declarationHeight + "px;");
          /** @type {Node} */
          const obj = vm.$refs.refDeclarationContent.cloneNode(true);
          vm.setDeclarationClass(obj);
          vm.$refs.refDeclarationDialogContent.$el.append(obj);
          vm.$refs.refDeclarationDialogContent.$el.setAttribute("style", "width: " + vm.declarationHeight + 10 + "px; height: " + vm.declarationHeight + "px;");
          domtoimage
            .toPng(obj)
            .then(function (dataUrl) {
              let img = new Image();
              img.src = dataUrl;
              const doc = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                //format: "a4",
                format: [210, 297],
              });
              doc.addImage(img, "PNG", 0, 0);

              // doc.addFileToVFS("Roboto-Regular.ttf", RobotoFont.base64);
              // doc.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
              // doc.setFont("Roboto-Regular"); // set font

              doc.save(vm.user.eik + "_DeclarationTremol.pdf", { returnPromise: true }).then(function () {
                vm.modalDeclaration = false;
                vm.$refs.refDeclarationDialogContent.$el.removeChild(obj);
              });
            })
            .catch(function (error) {
              vm.dialogLoader.showError(error);
            });
        });
      });
    },
    setDeclarationClass(node) {
      if (node.nodeType == 1) {
        node.setAttribute("class", "declaration " + node.getAttribute("class"));
        node.setAttribute("style", "color: black;" + node.getAttribute("style"));
      }
      if (node.hasChildNodes()) {
        node.childNodes.forEach((n) => {
          if (n.nodeType == 1) {
            this.setDeclarationClass(n);
          }
        });
      }
    },
    uploadSignedDeclaration(e, eik) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = () => {
        try {
          this.isSaveDisabled = true;
          let arrayBuffer = new Uint8Array(reader.result);
          if (window.document.documentMode) {
            throw Error("Декларацията не е подписана с електронен подпис!");
          } else {
            require("pdf-signature-reader")(reader.result);
          }
          var result = arrayBuffer.toBase64string();
          var o = { base64EncodedFile: result, clientToBeAddedEIK: eik };
          DataManager.updateUserSignedDeclaration(o, (error) => {
            if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
              this.dialogLoader.showInfo("Декларацията е изпратена успешно.\nЩе получите съобщение в уведомителната система когато декларацията бъде одобрена.");
            } else {
              this.dialogLoader.showError(error.Message);
            }
            setTimeout(() => {
              this.isSaveDisabled = false;
              this.$refs.refUpoadDeclaration.value = "";
            }, 3000);
          });
        } catch (ex) {
          this.dialogLoader.showError("Грешка при изпращане на декларация: " + ex.message);
          setTimeout(() => {
            this.isSaveDisabled = false;
            this.$refs.refUpoadDeclaration.value = "";
          }, 3000);
          return;
        }
      };
      reader.readAsArrayBuffer(file);
    },
    save() {},
    cancel() {},
    open() {},
    close() {},
  },
  computed: {},
  mounted() {},
};
</script>
<style scoped>
#dpi {
  height: 1cm;
  left: -100%;
  position: absolute;
  top: -100%;
  width: 1cm;
}

.a4border {
  padding-left: 2cm;
  padding-right: 1.5cm;
  padding-top: 1.5cm;
  padding-bottom: 1.5cm;
}

.declaration,
.declaration >>> v-input__slot {
  border-color: gray;
  color: black;
  background-color: white;
}
</style>